<template>
  <nav>
    <v-app-bar dark
               app
               color="primary">
      <v-app-bar-nav-icon v-if="isSmall" @click="toggleNavigation"/>

      <img class="header-logo ml-2" src="../../assets/logo-branca.png"
           alt="Logo da Proxpect"/>

      <px-top-menu-navigation />

      <v-spacer/>

      <px-notificacoes/>
      <px-carrinho v-if="hasRoleGestorCompras || hasRoleComprador"/>
      <px-user-info/>
    </v-app-bar>

    <px-naviagtion v-if="isSmall" v-model="navigationOpened" />
  </nav>
</template>

<script>
import TopMenuNavigation from '@/modules/navigation/TopMenuNavigation.vue';
import { mapGetters } from 'vuex';
import Navigation from '../navigation/Navigation.vue';

export default {
  data() {
    return {
      navigationOpened: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleGestorCompras', 'hasRoleComprador']),
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    toggleNavigation() {
      this.navigationOpened = !this.navigationOpened;
    },
  },
  components: {
    pxNaviagtion: Navigation,
    pxTopMenuNavigation: TopMenuNavigation,
  },
};
</script>

<style scoped>
  .header-logo {
    width: 180px;
  }
</style>
